export default __webpack_public_path__ + "static/media/american-express.bb88bd4d.svg";